export default "/images/fe17279c171f5398c42a7f16dc22d910.avif";